import React, { useEffect, useState } from "react";
import { createImageFromInitials, getInitials } from "../../AgentLogo";
import Avatar from "../../static/images/avata.svg";
import Meghna from "../../static/images/Meghna.jpg";
import pbLogo from "../../static/images/pb-logo-mobile.svg"

import CloseConfirmationDialog from "./chatElements/closeConfirmationDialog";
import { Product } from "../../constants";

export default function MotorChatHeader({ agentName, showModal, messageCounter, botName, miniMize, closeChat, roomClosed, source, sendMessage, productId }) {
  const [CloseConfirmation, setCloseConfirmation] = useState(false);
  const CallBackMsg = JSON.stringify({
    "title": "Request a Call Back",
    "type": "CustRequestCallBack"
  })
  const confirmationAction = (val) => {
    setCloseConfirmation(false);
    if (val) {
      closeChat()
      showModal();
    }
  }
  useEffect(() => {
    setCloseConfirmation(false)
  }, [roomClosed])
  return (
    <>
      <div className="mini car">
        <header >
          {/* {source === 'myacc' ?
            null :
            <span onClick={() => miniMize()} class="minimize"></span>
          } */}
          
          {source === "motorSeo" ?
            <>  <span onClick={() => miniMize()} class="minimize"></span>
              <span onClick={() => setCloseConfirmation(true)} class="close"></span>
            </> : null}

          <div class="heading-with-icon">
            {/* {agentName ?
              <div className="chaticon initial"  >
                {getInitials(agentName)}
                </div>
              : */}
           {!agentName?<img className="chaticon" src={Meghna} /> : <img className="chaticon" src={pbLogo} />}
            {/* } */}

            <div class="titlewrap">

              <div class="title"> {!agentName? "Megha" : agentName}
                <div className="carRating"></div>
                <div className="cardg">
                  {(productId === Product.CommercialVehicle)?<>
                    Commercial Vehicle Insurance Assistant
                  </>:<>
                    Car Insurance Assistant
                  </>}
                  
                </div> {messageCounter > 0 ? messageCounter : null}</div>
              <div class="subtitle"></div>
            </div>
          </div>
        </header>
      </div>
      {CloseConfirmation ?
        <CloseConfirmationDialog confirmationAction={confirmationAction} />
        : ""}
    </>
  );
}
